// Linear pipeline of stages with the current stage highlighted. A stage
// from `config.stages` matches `matter.stage` ignoring case, spaces,
// underscores and dashes, so a YAML may say "Master hearing" for masterHearing.

import type { WidgetProps } from "./types";
import { WidgetCard } from "./WidgetCard";

export function StageFunnelWidget({ config, matter }: WidgetProps) {
  const stages = (config.stages as string[] | undefined) ?? [];
  const current = (matter.stage ?? "").toLowerCase().replace(/[\s_-]/g, "");
  const idx = stages.findIndex((s) => s.toLowerCase().replace(/[\s_-]/g, "") === current);
  const title = config.title ?? "Pipeline";

  if (stages.length === 0) {
    return (
      <WidgetCard title={title}>
        <div style={{ fontSize: 12.5, color: "var(--muted)" }}>No pipeline configured.</div>
      </WidgetCard>
    );
  }

  return (
    <WidgetCard title={title} sub={`${idx >= 0 ? idx + 1 : "?"} / ${stages.length}`}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          alignItems: "center",
        }}
      >
        {stages.map((s, i) => {
          const isCurrent = i === idx;
          const isPast = idx >= 0 && i < idx;
          const bg = isCurrent ? "var(--olive)" : isPast ? "var(--ok-50)" : "var(--bg)";
          const color = isCurrent ? "#fff" : isPast ? "var(--ok-600)" : "var(--muted)";
          return (
            <span
              key={s}
              style={{
                display: "inline-flex",
                alignItems: "center",
                padding: "4px 8px",
                borderRadius: 4,
                fontSize: 11,
                fontWeight: isCurrent ? 700 : 500,
                background: bg,
                color,
                border: isCurrent ? "1px solid var(--olive)" : "1px solid var(--line)",
                whiteSpace: "nowrap",
              }}
            >
              {isPast && <span style={{ marginRight: 4 }}>✓</span>}
              {s}
            </span>
          );
        })}
      </div>
    </WidgetCard>
  );
}
